<!-- ========================  Rooms ======================== -->

<section class="page">

  <!-- ========================  Page header ======================== -->

  <div class="page-header" style="background-image:url(assets/images/header-1.jpg)">
    <div class="container">
      <h2 class="title">Empowered21 Rooms</h2>
      <p>At home in South Africa. </p>
    </div>
  </div>

  <!-- === rooms content === -->

  <div class="rooms rooms-category">
    <div class="container">

      <div class="row">

        <!-- === rooms item === -->

        <div *ngFor="let room of rooms$ | async" class="col-sm-6 col-md-6">
          <div class="item">
            <article>
              <!-- <div *ngIf="room.imageUrls[0]" class="image">
                <img src="{{room.imageUrls[0]}}" alt="{{room.name}}" />
              </div> -->
              <div class="details">
                <div class="text">
                  <h2 class="title">
                    <a>{{room.name}}</a>
                  </h2>
                  <!-- <p>
                    <a [routerLink]="['./', room.id]">View Room Details</a>
                  </p> -->
                </div>
                <div class="book">
                  <!-- <div>
                    <a [routerLink]="['./', room.id, 'booking', 'step-one']" class="btn btn-main">Book now</a>
                  </div> -->
                  <div>
                    <span class="price h4">{{room.minPrice | currency:'USD':'symbol':'3.2-2'}} to {{room.price | currency:'USD':'symbol':'3.2-2'}}</span>
                    <span>per night</span>
                  </div>
                  <div>
                    <ul>
                      <li *ngFor="let hotel of room.hotels">{{hotel}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>


      </div>

    </div>
    <!--/container-->
  </div>
</section>


<!-- ========================  Cards ======================== -->

<!-- <section class="cards"> -->

<!-- === cards header === -->

<!-- <div class="section-header">
            <div class="container">
                <h2 class="title">Tour Attractions </h2>
                <p>Here's a selection of tour sites you can include in your booking.</p>
            </div>
        </div> -->

<!-- <div class="container"> -->
<!-- <div class="row"> -->

<!-- === item === -->

<!-- <div class="col-xs-12 col-md-8">
                    <figure>
                        <figcaption style="background-image:url(assets/images/activity-1.jpg)">
                            <img src="assets/images/activity-1.jpg" alt="" />
                        </figcaption>
                        <a href="#" class="btn btn-clean" onclick="">Union Building</a>
                    </figure>
                </div> -->

<!-- === item === -->

<!-- <div class="col-xs-6 col-md-4">
                    <figure>
                        <figcaption style="background-image:url(assets/images/activity-2.jpg)">
                            <img src="assets/images/activity-2.jpg" alt="" />
                        </figcaption>
                        <a href="#" class="btn btn-clean">Emporers Palace</a>
                    </figure>
                </div> -->

<!-- === item === -->

<!-- <div class="col-xs-6 col-md-4">
                    <figure>
                        <figcaption style="background-image:url(assets/images/activity-3.jpg)">
                            <img src="assets/images/activity-3.jpg" alt="" />
                        </figcaption>
                        <a href="#" class="btn btn-clean">A</a>
                    </figure>
                </div> -->

<!-- === item === -->

<!-- <div class="col-xs-6 col-md-4">
                    <figure>
                        <figcaption style="background-image:url(assets/images/activity-4.jpg)">
                            <img src="assets/images/activity-4.jpg" alt="" />
                        </figcaption>
                        <a href="#" class="btn btn-clean">Shopping</a>
                    </figure>
                </div> -->

<!-- === item === -->

<!-- <div class="col-xs-6 col-md-4">
                    <figure>
                        <figcaption style="background-image:url(assets/images/activity-5.jpg)">
                            <img src="assets/images/activity-5.jpg" alt="" />
                        </figcaption>
                        <a href="#" class="btn btn-clean">The City</a>
                    </figure>
                </div> -->

<!-- </div>  -->

<!-- </div>  -->
<!-- </section> -->


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/rooms/rooms.component.html